import { type MouseEvent, type ReactNode } from 'react';
import { Pill } from '../../components/Pill/Pill';
import { renderOverflowTooltipLabel } from './OverflowTooltipLabel';
import { type Maybe } from '../maybe';

export interface SelectedPillEntry<T> {
    id: string;
    label: Maybe<string>;
    value: T;
}

interface SelectedValuePillsProps<T> {
    entries: SelectedPillEntry<T>[];
    wrapperClassName: string;
    pillClassName: string;
    pillLabelClassName: string;
    onDismiss: (value: T, event: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
}

export function SelectedValuePills<T>({
    entries,
    wrapperClassName,
    pillClassName,
    pillLabelClassName,
    onDismiss,
    disabled,
}: SelectedValuePillsProps<T>): ReactNode {
    if (entries.length === 0) {
        return null;
    }

    return (
        <div className={wrapperClassName}>
            {entries.map((entry) => (
                <Pill
                    key={entry.id}
                    className={pillClassName}
                    size="small"
                    onDismiss={
                        disabled
                            ? undefined
                            : (event) => {
                                  onDismiss(entry.value, event);
                              }
                    }
                    dismissAriaLabel={
                        entry.label ? `Remove ${entry.label}` : 'Remove'
                    }
                >
                    {renderOverflowTooltipLabel(
                        entry.label,
                        pillLabelClassName,
                    )}
                </Pill>
            ))}
        </div>
    );
}
